<template>
  <card>
    <div>
      <div class="row no-gutters">
        <div class="col-4 col-lg-5 col-xl-4" v-if="$slots.header">
          <slot name="header"></slot>
        </div>
        <div class="col-8 col-lg-7 col-xl-8" v-if="$slots.content">
          <slot name="content"></slot>
        </div>
      </div>
      <div v-if="$slots.footer">
        <hr />
        <slot name="footer"></slot>
      </div>
    </div>
  </card>
</template>
<script>
import Card from "./Card.vue";

export default {
  name: "stats-card",
  components: {
    Card,
  },
};
</script>
<style>
</style>
